// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { defineMessages } from "react-intl";

export const messages = defineMessages({
    search: {
        id: "apps.shared.components.folderSelection.search",
        description: "Search.",
        defaultMessage: "Search...",
    },
    searchFolders: {
        id: "apps.shared.components.folderSelection.searchFolders",
        description: "Search folders.",
        defaultMessage: "Filter Lens Folders...",
    },
});
